import { flatten, isEmpty, map, size } from 'lodash/fp';
import { H2 } from '@ahmdigital/ui';
import React from 'react';

import { Tile } from '../../content-tiles-section/types';
import { TileWrapper } from './styles';
import InformationTile from '../../information-tile';
import WrappedSection from '../wrapped-section';

type Props = {
  content: Tile[][] | undefined;
};

const InformationSection = ({ content }: Props) => {
  const formattedContent = flatten(content);
  if (isEmpty(formattedContent)) {
    return null;
  }

  return (
    <WrappedSection withBorder withWide>
      <H2 variant={['center', 'marginBottomSpacer8']}>Handy links</H2>
      <TileWrapper tileThreshold={size(formattedContent)}>
        {map(
          (tile) => (
            <InformationTile {...tile} />
          ),
          formattedContent,
        )}
      </TileWrapper>
    </WrappedSection>
  );
};

export default InformationSection;
